import React, {useContext} from 'react';
import { useHistory } from 'react-router-dom';

import './kreirajnajavu.css';
import Input from '../../utils/input/Input';
import {VALIDATOR_REQUIRE} from '../../utils/input/validators';
import ImageUpload from '../../utils/imageupload/ImageUpload';
import {useForm} from '../../utils/input/form-hook';
import LoadingSpinner from '../../utils/loader/LoadingSpinner';
import {useHttpClient} from '../../utils/input/http-hook';
import {AuthContext} from '../../utils//context/auth-context';

const KreirajNajavu = () => {    

    const auth = useContext(AuthContext);
    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const [formState, inputHandler] = useForm(
        {
          naslov: {
            value: '',
            isValid: false
          },
          plan: {
            value: '',
            isValid: false
          },
          datum: {
            value: '',
            isValid: false
          },
          kategorija: {
            value: '',
            isValid: false
          },
          duzina: {
            value: '',
            isValid: false
          },
          visina: {
            value: '',
            isValid: false
          },
          tezina: {
            value: '',
            isValid: false
          },
          organizator: {
            value: '',
            isValid: false
          },
          kontakt: {
            value: '',
            isValid: false
          },
          cena: {
            value: '',
            isValid: false
          },
          image: {
            value: null,
            isValid: false
          }  
        },
        false
      );
    
      const history = useHistory();


      // const placeSubmitHandler = event => {
      //   event.preventDefault();
      //   console.log(formState.inputs); // send this to the backend!
      // };

      const placeSubmitHandler = async event => {      
        event.preventDefault();      
        try {      
          const formData =  new FormData(); 
          formData.append('naslov', formState.inputs.naslov.value);  
          formData.append('datum', formState.inputs.datum.value); 
          formData.append('plan', formState.inputs.plan.value); 
          formData.append('kategorija', formState.inputs.kategorija.value);  
          formData.append('duzina', formState.inputs.duzina.value); 
          formData.append('visina', formState.inputs.visina.value); 
          formData.append('tezina', formState.inputs.tezina.value);
          formData.append('organizator', formState.inputs.organizator.value);
          formData.append('kontakt', formState.inputs.kontakt.value); 
          formData.append('cena', formState.inputs.cena.value);   
          formData.append('image', formState.inputs.image.value);   
          await sendRequest(
            process.env.REACT_APP_BECKEND_URL+'/najave',
            'POST',
            formData, 
            {Authorization: 'Bearer ' + auth.token}
          );
          history.push('/');
        } catch (err) {}
      };
    
        
    
       return (
        <section className="section-book ">
                <div className="row">
                    <div className="book-najava">
                        <div className="book-najava__form ">
                        <form className="form" onSubmit={placeSubmitHandler}>
                                <div className="u-margin-bottom-small">
                                    <h2 className="heading-secondary">
                                        Kreiraj Najavu
                                    </h2>
                                </div>
                                

                                <div className="form__group">
                                    <Input 
                                        id="naslov"
                                        element="input" 
                                        type="text"
                                        label="Naslov" 
                                        validators={[VALIDATOR_REQUIRE()]} 
                                        // errorText="error"
                                        onInput={inputHandler}
                                     ></Input>                                   
                                </div>

                                <div className="form__group">
                                <Input 
                                        id="datum"
                                        element="input" 
                                        type="date"
                                        label="Datum" 
                                        validators={[VALIDATOR_REQUIRE()]} 
                                        // errorText="error"
                                        onInput={inputHandler}
                                     ></Input>                                    
                                </div>

                                <div className="form__group">
                                <Input 
                                        id="kategorija"
                                        element="input" 
                                        type="text"
                                        label="Kategorija" 
                                        validators={[VALIDATOR_REQUIRE()]} 
                                        // errorText="error"
                                        onInput={inputHandler}
                                     ></Input>                                    
                                </div>
                                <div className="form__group">
                                <Input 
                                        id="duzina"
                                        element="input" 
                                        type="number"
                                        label="Duzina Staze" 
                                        validators={[VALIDATOR_REQUIRE()]} 
                                        // errorText="error"
                                        onInput={inputHandler}
                                     ></Input>                                    
                                </div>
                                <div className="form__group">
                                <Input 
                                        id="visina"
                                        element="input" 
                                        type="number"
                                        label="Visina" 
                                        validators={[VALIDATOR_REQUIRE()]} 
                                        // errorText="error"
                                        onInput={inputHandler}
                                     ></Input>                                    
                                </div>
                                <div className="form__group">
                                <Input 
                                        id="cena"
                                        element="input" 
                                        type="number"
                                        label="Cena" 
                                        validators={[VALIDATOR_REQUIRE()]} 
                                        // errorText="error"
                                        onInput={inputHandler}
                                     ></Input>                                    
                                </div>
                                <div className="form__group">
                                <Input 
                                        id="tezina"
                                        element="input" 
                                        type="text"
                                        label="Tezina Staze" 
                                        validators={[VALIDATOR_REQUIRE()]} 
                                        // errorText="error"
                                        onInput={inputHandler}
                                     ></Input>                                    
                                </div>
                                <div className="form__group">
                                <Input 
                                        id="organizator"
                                        element="input" 
                                        type="text"
                                        label="Organizator" 
                                        validators={[VALIDATOR_REQUIRE()]} 
                                        // errorText="error"
                                        onInput={inputHandler}
                                     ></Input>                                    
                                </div>
                                <div className="form__group">
                                <Input 
                                        id="kontakt"
                                        element="input" 
                                        type="number"
                                        label="Kontakt telefon" 
                                        validators={[VALIDATOR_REQUIRE()]} 
                                        // errorText="error"
                                        onInput={inputHandler}
                                     ></Input>                                    
                                </div>

                                <ImageUpload center id="image"  onInput={inputHandler} /> 

                                <div className="form__group">
                                <Input 
                                        id="plan"
                                        element="textarea" 
                                        type="text"
                                        label="Plan Acije" 
                                        validators={[VALIDATOR_REQUIRE()]} 
                                        rows="4"
                                        // errorText="error"
                                        onInput={inputHandler}
                                     ></Input>                                   
                                </div>

                                <div className="form__group">
                                    <button className="btn btn--green" type="submit" disabled={!formState.isValid}>Kreiraj</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
       )
    };


export default KreirajNajavu;